const storageKey = 'ftuxwalkthrough.dismissed';

export function shouldShowFtuxWalkthrough() {
  return !Boolean(localStorage.getItem(storageKey));
}

export function dismiss() {
  return new Promise(resolve => {
    localStorage.setItem(storageKey, 1);
    resolve();
  });
}
